export enum FullScreenBehaviourType {
  DISABLED = 'disabled',
  SHOW_AS_BUTTON = 'show_as_button',
  AUTOMATICALLY = 'automatically',
}
